module.exports = __webpack_public_path__ + "img/arrows.8b3ad1a2.svg";